import api from './baseService';

export interface PortOfEntry {
	port_of_entry_code: string;
	port_of_entry_name: string;
	status: string;
}

export const getPortsOfEntry = () =>
	api().get<PortOfEntry[]>('/pdb/physicalorders/ports_of_entry');

export const postPortOfEntry = (payload: Record<string, any>) =>
	api().post('/pdb/physicalorders/ports_of_entry', payload);

export const putPortOfEntry = (port_of_entry_code: string, payload: Record<string, any>) =>
	api().put(`/pdb/physicalorders/ports_of_entry/${port_of_entry_code}`, payload);
